import helper from "@/form_builder/components/form/ui/helper.js";

export default {
  vue_tag: "input",
  tag: "el-input",
  name: "Tipo URL",
  title:
    "Campo para ingresar una URL válida (enlace web). Se recomienda para capturar sitios, portafolios, referencias, etc.",
  __openRules: true,
  tagIcon: "link",
  __ID: "",
  defaultvalue: "",

  formItem: {
    showLabel: helper.input_boolean("Mostrar etiqueta", true),
    label: helper.input_text("Etiqueta", "URL"),
  },
  attrs: {
    fieldName: helper.input_text("Nombre de campo", "url"),
    placeholder: helper.input_text("Ejemplo de entrada", "https://ejemplo.com"),
    type: helper.input_select(
      "Tipo",
      [
        {
          key: "url",
          value: "URL",
        },
      ],
      "url"
    ),
    pattern: helper.input_text("Patrón de validación (opcional)", "https://.*"),
  },

  props: {},

  childrens: [],
  ctrlBtn: true,
  slots: {
    prefix: helper.input_text("box header", ""),
    suffix: helper.input_text("content at the end", ""),
    prepend: helper.input_text("box prepend", ""),
    append: helper.input_text("content after", ""),
  },

  rule: {
    required: helper.input_boolean("必填", false),
    pattern: helper.input_text("Patrón de validación (opcional)", "https://.*"),
  },
};
